import request from '@/router/axios';

export function fetchList(query) {
  return request({
    url: '/system/user/page',
    method: 'get',
    params: query,
  });
}

export function addObj(obj) {
  return request({
    url: '/system/user',
    method: 'post',
    data: obj,
  });
}

export function getObj(id) {
  return request({
    url: '/system/user/' + id,
    method: 'get',
  });
}
export function info(username) {
  return request({
    url: '/system/user/info/' + username,
    method: 'get',
  });
}

export function delObj(id) {
  return request({
    url: '/system/user/' + id,
    method: 'delete',
  });
}

export function putObj(obj) {
  return request({
    url: '/system/user',
    method: 'put',
    data: obj,
  });
}

export function getDetails(obj) {
  return request({
    url: '/system/user/details/' + obj,
    method: 'get',
  });
}

export function listByRoleCode(roleCode) {
  return request({
    url: '/system/user/listByRoleCode/' + roleCode,
    method: 'get',
  });
}

export function getByStaffId(staffId) {
  return request({
    url: '/system/user/byStaffId/' + staffId,
    method: 'get',
  });
}

export function updatePasswordSyncTalent(obj) {
  return request({
    url: '/dotadmin/dotadmin/user/updatePasswordSyncTalent',
    method: 'post',
    data: obj,
  });
}
